var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "month-report-wrap" },
    [
      _c(
        "handleIcon",
        {
          attrs: { isAllScreen: _vm.isAllScreen },
          on: {
            allScreen: function ($event) {
              return _vm.toggleAllScreenFull(!_vm.isAllScreen)
            },
          },
        },
        [
          _c("template", { slot: "menu" }, [
            _c(
              "li",
              {
                on: {
                  click: function () {
                    return _vm.getAllData()
                  },
                },
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "iconfont iconRefresh" }),
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("dashboard-bi::default-board::refresh"))
                  ),
                ]),
              ]
            ),
          ]),
        ],
        2
      ),
      _c(
        "el-card",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c("label", { staticClass: "label-item" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("operate-analysis::month-report::shop_name")
                      )
                    ),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "search-item",
                      attrs: {
                        placeholder: _vm.$t(
                          "system::common::select_placeholder"
                        ),
                        popperAppendToBody: false,
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.changeShop },
                      model: {
                        value: _vm.params.shopId,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "shopId", $$v)
                        },
                        expression: "params.shopId",
                      },
                    },
                    _vm._l(_vm.shopList, function (item) {
                      return _c("el-option", {
                        key: item.shopId,
                        attrs: { label: item.shopName, value: item.shopId },
                      })
                    }),
                    1
                  ),
                  _c("label", { staticClass: "label-item" }, [
                    _vm._v(
                      _vm._s(_vm.$t("operate-analysis::month-report::month"))
                    ),
                  ]),
                  _c("el-date-picker", {
                    staticClass: "day-item",
                    attrs: {
                      appendToBody: false,
                      clearable: false,
                      type: "daterange",
                      align: "right",
                      "unlink-panels": "",
                      "range-separator": "~",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "picker-options": _vm.pickerOptions,
                    },
                    on: { change: _vm.handlerDateChange },
                    model: {
                      value: _vm.date,
                      callback: function ($$v) {
                        _vm.date = $$v
                      },
                      expression: "date",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticClass: "card-content",
          attrs: { gutter: 16, span: 20, justify: "space-between" },
        },
        _vm._l(_vm.cardOptions, function (item, index) {
          return _c(
            "el-col",
            {
              key: index,
              staticClass: "card-item",
              attrs: { lg: 4, md: 12, xl: 4 },
            },
            [
              _c("dataCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.cardLoading,
                    expression: "cardLoading",
                  },
                ],
                attrs: { active: 0, option: item },
              }),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 16 } },
        [
          _vm.reports.includes(12431)
            ? _c(
                "el-col",
                { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
                [
                  _c("reportCard", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.reportCardLoading,
                        expression: "reportCardLoading",
                      },
                    ],
                    style: "height: " + _vm.reportHeight + ";",
                    attrs: { config: _vm.saleTrendData },
                    on: { btns: _vm.onReportBtns },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.reports.includes(13049)
            ? _c(
                "el-col",
                { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
                [
                  _c(
                    "reportTable",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading.siteTable,
                          expression: "loading.siteTable",
                        },
                      ],
                      ref: "siteTable",
                      style: "height: " + _vm.reportHeight + ";",
                      attrs: { config: _vm.siteTableConfig },
                      on: {
                        onEnd: _vm.onSiteTableEnd,
                        btns: _vm.onReportBtns,
                        "sort-change": _vm.siteSortChange,
                      },
                    },
                    [
                      _vm._l(
                        _vm.siteTableConfig.columns,
                        function (item, index) {
                          return [
                            _c("el-table-column", {
                              key: index,
                              attrs: {
                                label: item,
                                "min-width": "130",
                                sortable:
                                  (item === "客单价" ||
                                    item === "成交额" ||
                                    item === "连带率") &&
                                  "custom",
                                prop: item,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                                          scope.row[item]
                                        )
                                          ? _c("el-image", {
                                              staticClass: "goods-image",
                                              attrs: { src: scope.row[item] },
                                            })
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$dataCheck(
                                                    scope.row[item]
                                                  )
                                                )
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.reports.includes(13050)
            ? _c(
                "el-col",
                { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
                [
                  _c(
                    "reportTable",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.optimizerTableLoading,
                          expression: "optimizerTableLoading",
                        },
                      ],
                      ref: "optimizerTable",
                      style: "height: " + _vm.reportHeight + ";",
                      attrs: { config: _vm.optimizerTableConfig },
                      on: {
                        btns: _vm.onReportBtns,
                        onEnd: _vm.onOptimizerTableEnd,
                      },
                    },
                    [
                      _vm.optimizerTableConfig &&
                      _vm.optimizerTableConfig.columns &&
                      _vm.optimizerTableConfig.columns.length
                        ? _c("el-table-column", {
                            key: "index",
                            attrs: {
                              prop: "index",
                              label: "序号",
                              "min-width": "60",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var $index = ref.$index
                                    return [
                                      _c("span", [_vm._v(_vm._s($index + 1))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1065934640
                            ),
                          })
                        : _vm._e(),
                      _vm._l(
                        _vm.optimizerTableConfig.columns,
                        function (item, index) {
                          return [
                            _c("el-table-column", {
                              key: index,
                              attrs: {
                                prop: item,
                                label: item,
                                "min-width": "120",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                                          scope.row[item]
                                        )
                                          ? _c("el-image", {
                                              staticClass: "goods-image",
                                              attrs: { src: scope.row[item] },
                                            })
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$dataCheck(
                                                    scope.row[item]
                                                  )
                                                )
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.reports.includes(12430)
            ? _c(
                "el-col",
                { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
                [
                  _c(
                    "reportTable",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading.salesTable,
                          expression: "loading.salesTable",
                        },
                      ],
                      ref: "salesTable",
                      style: "height: " + _vm.reportHeight + ";",
                      attrs: { config: _vm.salesTable },
                      on: {
                        btns: _vm.onReportBtns,
                        onEnd: _vm.onSalesTableEnd,
                        "sort-change": _vm.salesSortChange,
                      },
                    },
                    [
                      _vm.salesTable &&
                      _vm.salesTable.columns &&
                      _vm.salesTable.columns.length
                        ? _c("el-table-column", {
                            key: "index",
                            attrs: {
                              prop: "index",
                              label: "序号",
                              "min-width": "60",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var $index = ref.$index
                                    return [
                                      _c("span", [_vm._v(_vm._s($index + 1))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1065934640
                            ),
                          })
                        : _vm._e(),
                      _vm._l(_vm.salesTable.columns, function (item, index) {
                        return [
                          _c("el-table-column", {
                            key: index,
                            attrs: {
                              prop: item,
                              label: item,
                              sortable:
                                (item === "销量" || item === "成交额") &&
                                "custom",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                                        scope.row[item]
                                      )
                                        ? _c("el-image", {
                                            staticClass: "goods-image",
                                            attrs: { src: scope.row[item] },
                                          })
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$dataCheck(scope.row[item])
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }